"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDfracBraces = fixDfracBraces;
const tex_syntax_1 = require("./tex-syntax");
const dfracFirstArgWithMissingBraces = new RegExp(`(\\\\dfrac)(\\\\${tex_syntax_1.color}${(0, tex_syntax_1.arg)(1)}|\\d)`, "g");
const dfracSecondArgWithMissingBraces = new RegExp(`(\\\\dfrac${(0, tex_syntax_1.block)(2)})(\\s*\\\\${tex_syntax_1.color}${(0, tex_syntax_1.arg)(1)})`, "g");
function fixDfracBraces(tex) {
    return tex
        .replace(dfracFirstArgWithMissingBraces, "$1{$2}")
        .replace(dfracSecondArgWithMissingBraces, "$1{$2}");
}
